import Box from '@mui/material/Box';

/** First focusable element on every page (§50). */
export function SkipLink({ targetId }: { targetId: string }) {
  return (
    <Box
      component="a"
      href={`#${targetId}`}
      sx={{
        position: 'fixed',
        top: 8,
        left: 8,
        zIndex: 'tooltip',
        px: 4,
        py: 2,
        borderRadius: 1,
        bgcolor: 'background.paper',
        color: 'text.primary',
        fontWeight: 700,
        transform: 'translateY(-200%)',
        '&:focus': { transform: 'none' },
      }}
    >
      Skip to main content
    </Box>
  );
}
